import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CurrencyInput from 'react-currency-input';
import { PowerSelect } from 'react-power-select';
import 'react-power-select/dist/react-power-select.css';
import CompaniesDropdown from '../companies/companies-dropdown.jsx';

export default class AddNewUnit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      companies: props.companiesAll || [],
      selectedCustomerId: null,
      unit_short_code:'',
    };
    this.handleAddNewUnitCreate = this.handleAddNewUnitCreate.bind(this);
    this.handleChangeUnitName = this.handleChangeUnitName.bind(this);
  }

  handleCustomerSelection(option) {
    this.setState({ selectedCustomerId: option.id });
  }

  handleAddNewUnitCreate(e) {
    e.preventDefault();
    let newDriverData = {
      api_token: window.api_token,
      company_id: $('[name=company_id]').val(),
      unit_name: $('[name=unit_name]').val(),
      unit_short_code: $('[name=unit_short_code]').val(),
      unit_total_qty_per_yard: $('[name=unit_total_qty_per_yard]').val(),
      yard: $('[name=yard]').val(),
    }

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/portal-admin/add-new-unit',
      data: newDriverData,
      dataType: "text/json",
      complete: function (response) {
        if (response.status == 200) {
          $('#infomodallabel').html('New Unit Type Created');
          $('#infomodal .modal-body').html('New Unit Type Created');
          $('#infomodal').modal();
          $('input').val('');
          $('textarea').val('');
        }
        else {
          $('#infomodallabel').html('Error adding new Unit Type');
          $('#infomodal .modal-body').html($.parseHTML(response.responseText.replace(/\"/g, "")));
          $('#infomodal').modal();
        }
      }
    });
  }

  handleToggleAddNewUnit() {
    $('#add_new_unit_form').slideToggle();
    $('.add-new-unit-button').toggleClass('text-center').toggleClass('opened-button-for-slidedown-content');
    $('#slide-toggle-icon').toggleClass('fa-minus-circle');
    $('#slide-toggle-icon').toggleClass('fa-plus-circle');
    $('#react-component-g4-logistics-portal-add-new-unit').toggleClass('active');
  }

  handleChangeUnitName(e){
    this.setState({unit_short_code: _.snakeCase(e.target.value)});
  }
  
  render() {
    
    return (
      <div>
        <button className="text-center btn btn-lg btn-light add-new-unit-button"
          type="button" onClick={this.handleToggleAddNewUnit}>
          <i className="fa fa-plus-circle" id="slide-toggle-icon"></i>&nbsp;
          Add New Unit
        </button>

        <form id="add_new_unit_form" ref="AddNewUnitForm" >
          <fieldset>
            <br />
            <br />
            <h1>Add New Unit</h1>
            <br />

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <label>Unit Company</label>
                      <CompaniesDropdown />

                    </div>
                    <div className="col-md-6">
                      <label>Yard</label>
                      <select className="form-control form-control-lg" name="yard" id="yard">
                        <option value="Ditton">Ditton</option>
                        <option value="Blackhouse">Blackhouse</option>
                        <option value="Cheadle ">Cheadle</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor="unit_name">Unit Name</label>
                      <input type="text" name="unit_name" id="unit_name"
                        className="form-control form-control-lg" onChange={this.handleChangeUnitName}/>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="unit_short_code">Unit Short Code</label>
                      <input type="text" name="unit_short_code" id="unit_short_code"
                        className="form-control form-control-lg" readOnly value={this.state.unit_short_code}/>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="unit_total_qty_per_yard">Unit Total Qty Per Yard</label>
                      <input type="text" name="unit_total_qty_per_yard" id="unit_total_qty_per_yard"
                        className="form-control form-control-lg text-center" min="0" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <button className="btn btn-lg btn-primary" onClick={this.handleAddNewUnitCreate} type="button"> Add New Unit </button>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

if (document.getElementById('react-component-g4-logistics-portal-add-new-unit')) {
  ReactDOM.render(<AddNewUnit />, document.getElementById('react-component-g4-logistics-portal-add-new-unit'));
}
